import Typography from "@mui/material/Typography";
import {Grid2} from "@mui/material";
import React from "react";

type Hour = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 13 | 14 | 15 | 16 | 17 | 18 | 19 | 20 | 21 | 22 | 23;
type Minute = 0 | 5 | 10 | 15 | 20 | 25 | 30 | 35 | 40 | 45 | 50 | 55;

interface FixedTime {
    hour: Hour;
    minute: Minute;
}

interface OpeningHourDayDTO {
    dayOfWeek: number,
    start1: FixedTime | null,
    end1: FixedTime | null,
    start2: FixedTime | null,
    end2: FixedTime | null,
    isClosed: boolean
}

const MAPPING_DAY_NUMBER_TEXT: Map<number, string> = new Map([
    [0, "Lundi"],
    [1, "Mardi"],
    [2, "Mercredi"],
    [3, "Jeudi"],
    [4, "Vendredi"],
    [5, "Samedi"],
    [6, "Dimanche"],
]);

const formatHour = (fixedTime: FixedTime): string => {
    if (fixedTime.minute === 0) {
        return `${fixedTime.hour}h00`
    }

    if (fixedTime.minute === 5) {
        return `${fixedTime.hour}h05`
    }

    return `${fixedTime.hour}h${fixedTime.minute}`
}

const formatOpeningHours = (openingHourDay: OpeningHourDayDTO): string => {
    if (openingHourDay.isClosed) {
        return "Fermé"
    }

    if (!openingHourDay.start2 || !openingHourDay.end2) {
        return `${formatHour(openingHourDay.start1!)}-${formatHour(openingHourDay.end1!)}`
    }

    return `${formatHour(openingHourDay.start1!)}-${formatHour(openingHourDay.end1!)} et ${formatHour(openingHourDay.start2)}-${formatHour(openingHourDay.end2)}`
}

const formatFullOpeningHourDay = (openingHourDay: OpeningHourDayDTO): string => {
    return `${MAPPING_DAY_NUMBER_TEXT.get(openingHourDay.dayOfWeek)} ${formatOpeningHours(openingHourDay)}`
}

const OPENING_HOURS_DATA: OpeningHourDayDTO[] = [
    {
        dayOfWeek: 0,
        start1: {hour: 8, minute: 15},
        end1: {hour: 12, minute: 15},
        start2: null,
        end2: null,
        isClosed: false,
    },
    {
        dayOfWeek: 1,
        start1: {hour: 8, minute: 15},
        end1: {hour: 8, minute: 15},
        start2: {hour: 8, minute: 15},
        end2: {hour: 8, minute: 15},
        isClosed: true,
    },
    {
        dayOfWeek: 2,
        start1: {hour: 8, minute: 15},
        end1: {hour: 8, minute: 15},
        start2: {hour: 8, minute: 15},
        end2: {hour: 8, minute: 15},
        isClosed: false,
    },
    {
        dayOfWeek: 3,
        start1: {hour: 6, minute: 25},
        end1: {hour: 9, minute: 30},
        start2: {hour: 11, minute: 0},
        end2: {hour: 14, minute: 15},
        isClosed: false,
    },
    {
        dayOfWeek: 4,
        start1: {hour: 8, minute: 15},
        end1: {hour: 8, minute: 15},
        start2: {hour: 8, minute: 15},
        end2: {hour: 8, minute: 15},
        isClosed: false,
    },
    {
        dayOfWeek: 5,
        start1: {hour: 8, minute: 15},
        end1: {hour: 8, minute: 15},
        start2: {hour: 8, minute: 15},
        end2: {hour: 8, minute: 15},
        isClosed: false,
    },
    {
        dayOfWeek: 6,
        start1: {hour: 8, minute: 15},
        end1: {hour: 8, minute: 15},
        start2: {hour: 13, minute: 15},
        end2: {hour: 18, minute: 30},
        isClosed: false,
    },
];

const OpeningHours = () => {
    return (
        <Grid2 container size={12} textAlign={{xs: "center", md: "left"}}>

            <Typography
                width={"100%"}
                sx={{
                    color: '#ffffff',
                    fontSize: {xs: 22, sm: 24, md: 26},
                }}
                variant={"firstVariant"}
            >
                Horaires
            </Typography>

            {OPENING_HOURS_DATA.map((openingHourDay: OpeningHourDayDTO) => {
                return (
                    <Typography
                        key={openingHourDay.dayOfWeek}
                        fontSize={{xs: 16, sm: 18, md: 20}}
                        variant={"fourthVariant"}
                        width={"100%"}
                    >
                        {formatFullOpeningHourDay(openingHourDay)}
                    </Typography>
                )
            })}

        </Grid2>
    );
}

export default OpeningHours